var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbNetworkRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-31 -1387) translate(31 1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.106 13.686h13.74v-3.053H9.106zM9.106 3v3.053h13.74V3zm0 18.319h13.74v-3.053H9.106zM3 13.686h3.053v-3.053H3zM3 3v3.053h3.053V3zm0 18.319h3.053v-3.053H3z",
    transform: "translate(-31 -1387) translate(30 1387)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNetworkRules);
export default __webpack_public_path__ + "static/media/rb-network-rules.467fb8fa8cf3fb33f89277d5a76ccca8.svg";
export { ForwardRef as ReactComponent };